// ============================================================================
// HOME · the Collection tile's numbers (CLB-069 · Stage 4a)
// ============================================================================
// The tile shows each line's count exactly as the Wall's Sun | Optic switch does:
// ordered models only, new cards + repeats (collectionFacets.lineTotal) — and never
// a number before BOTH reads of a line have answered. The reads are the Wall's own
// (same query keys), so opening the Wall afterwards lands on a warm cache. Home
// does not poll: poll:false on the repeats, none on the cards. `enabled` is false
// until the tile is actually on this person's Home (no access → no read).
// ============================================================================
import { useCollectionCards } from '../../../portals/orders/collection/useCollectionCards';
import { useCollectionRepeats } from '../../../portals/orders/collection/useCollectionRepeats';
import { lineTotal } from '../../../portals/orders/collection/collectionFacets';
import { seasonCode } from '../../../portals/orders/collection/seasonCode';

export function useHomeCollectionCounts(enabled = true) {
  const sun = useCollectionCards(undefined, { line: 'sun', enabled });
  const sunRep = useCollectionRepeats(undefined, { line: 'sun', enabled, poll: false });
  const optic = useCollectionCards(undefined, { line: 'optic', enabled });
  const opticRep = useCollectionRepeats(undefined, { line: 'optic', enabled, poll: false });
  return {
    season: seasonCode(sun.season || optic.season),
    lines: { sun: lineTotal(sun, sunRep, false), optic: lineTotal(optic, opticRep, false) },
  };
}
